'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSigner$002dRole from "./presto.types$-Signer-Role.js";
import * as $j_presto$002etypes$0024$002dSigner$002dRole$0024$0024anon$002430 from "./presto.types$-Signer-Role$$anon$30.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SignerRole$$anon$32(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$SignerRole$$anon$32 as $c_Lpresto_types$SignerRole$$anon$32 };
$p = $c_Lpresto_types$SignerRole$$anon$32.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SignerRole$$anon$32;
/** @constructor */
function $h_Lpresto_types$SignerRole$$anon$32() {
}
export { $h_Lpresto_types$SignerRole$$anon$32 as $h_Lpresto_types$SignerRole$$anon$32 };
$h_Lpresto_types$SignerRole$$anon$32.prototype = $p;
$p.bO = (function(text) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$SignerRole$().cxx(text));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a8 : e$2);
    }
  }
});
$p.cBS = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it.l());
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a8 : e$2);
    }
  }
});
$p.bK = (function(t) {
  return this.cBS(t);
});
var $d_Lpresto_types$SignerRole$$anon$32 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SignerRole$$anon$32, "presto.types$SignerRole$$anon$32", ({
  a1N: 1,
  K: 1
}));
export { $d_Lpresto_types$SignerRole$$anon$32 as $d_Lpresto_types$SignerRole$$anon$32 };
function $s_Lpresto_types$SignerRole$__Parte__Lpresto_types$SignerRole() {
  $m_Lpresto_types$SignerRole$();
  return $t_Lpresto_types$SignerRole$__Parte;
}
export { $s_Lpresto_types$SignerRole$__Parte__Lpresto_types$SignerRole as $s_Lpresto_types$SignerRole$__Parte__Lpresto_types$SignerRole };
function $s_Lpresto_types$SignerRole$__Testemunha__Lpresto_types$SignerRole() {
  $m_Lpresto_types$SignerRole$();
  return $t_Lpresto_types$SignerRole$__Testemunha;
}
export { $s_Lpresto_types$SignerRole$__Testemunha__Lpresto_types$SignerRole as $s_Lpresto_types$SignerRole$__Testemunha__Lpresto_types$SignerRole };
/** @constructor */
function $c_Lpresto_types$SignerRole$() {
  this.cbZ = null;
  this.cc2 = null;
  this.cc3 = false;
  this.cc0 = null;
  this.cc1 = false;
  this.cc4 = null;
  this.cc5 = false;
  $n_Lpresto_types$SignerRole$ = this;
  $t_Lpresto_types$SignerRole$__Parte = new $j_presto$002etypes$0024$002dSigner$002dRole$0024$0024anon$002430.$c_Lpresto_types$SignerRole$$anon$30(0, "Parte", this);
  $t_Lpresto_types$SignerRole$__Testemunha = new $j_presto$002etypes$0024$002dSigner$002dRole$0024$0024anon$002430.$c_Lpresto_types$SignerRole$$anon$30(1, "Testemunha", this);
  this.cbZ = new ($j_presto$002etypes$0024$002dSigner$002dRole.$d_Lpresto_types$SignerRole.r().C)([$s_Lpresto_types$SignerRole$__Parte__Lpresto_types$SignerRole(), $s_Lpresto_types$SignerRole$__Testemunha__Lpresto_types$SignerRole()]);
}
export { $c_Lpresto_types$SignerRole$ as $c_Lpresto_types$SignerRole$ };
$p = $c_Lpresto_types$SignerRole$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SignerRole$;
/** @constructor */
function $h_Lpresto_types$SignerRole$() {
}
export { $h_Lpresto_types$SignerRole$ as $h_Lpresto_types$SignerRole$ };
$h_Lpresto_types$SignerRole$.prototype = $p;
$p.cSi = (function() {
  return this.cbZ.at();
});
$p.cxx = (function(\u03b4name) {
  if ((\u03b4name === "Parte")) {
    return $s_Lpresto_types$SignerRole$__Parte__Lpresto_types$SignerRole();
  }
  if ((\u03b4name === "Testemunha")) {
    return $s_Lpresto_types$SignerRole$__Testemunha__Lpresto_types$SignerRole();
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
});
$p.cJj = (function() {
  if ((!this.cc3)) {
    this.cc2 = new $c_Lpresto_types$SignerRole$$anon$31(this);
    this.cc3 = true;
  }
  return this.cc2;
});
$p.pf = (function() {
  if ((!this.cc1)) {
    this.cc0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$SignerRole$().cxx(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a8 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9);
    this.cc1 = true;
  }
  return this.cc0;
});
$p.cto = (function() {
  if ((!this.cc5)) {
    this.cc4 = new $c_Lpresto_types$SignerRole$$anon$32(this);
    this.cc5 = true;
  }
  return this.cc4;
});
var $d_Lpresto_types$SignerRole$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SignerRole$, "presto.types$SignerRole$", ({
  a1K: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$SignerRole$ as $d_Lpresto_types$SignerRole$ };
var $n_Lpresto_types$SignerRole$;
function $m_Lpresto_types$SignerRole$() {
  if ((!$n_Lpresto_types$SignerRole$)) {
    $n_Lpresto_types$SignerRole$ = new $c_Lpresto_types$SignerRole$();
  }
  return $n_Lpresto_types$SignerRole$;
}
export { $m_Lpresto_types$SignerRole$ as $m_Lpresto_types$SignerRole$ };
/** @constructor */
function $c_Lpresto_types$SignerRole$$anon$31(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$SignerRole$$anon$31 as $c_Lpresto_types$SignerRole$$anon$31 };
$p = $c_Lpresto_types$SignerRole$$anon$31.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SignerRole$$anon$31;
/** @constructor */
function $h_Lpresto_types$SignerRole$$anon$31() {
}
export { $h_Lpresto_types$SignerRole$$anon$31 as $h_Lpresto_types$SignerRole$$anon$31 };
$h_Lpresto_types$SignerRole$$anon$31.prototype = $p;
$p.a1 = (function(a) {
  $m_Lpresto_types$SignerRole$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Json$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Json$JString(a.l());
});
var $d_Lpresto_types$SignerRole$$anon$31 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SignerRole$$anon$31, "presto.types$SignerRole$$anon$31", ({
  a1M: 1,
  a: 1,
  l: 1
}));
export { $d_Lpresto_types$SignerRole$$anon$31 as $d_Lpresto_types$SignerRole$$anon$31 };
var $t_Lpresto_types$SignerRole$__Parte = null;
function $u_Lpresto_types$SignerRole$__Parte(x) {
  $t_Lpresto_types$SignerRole$__Parte = x;
}
export { $t_Lpresto_types$SignerRole$__Parte as $t_Lpresto_types$SignerRole$__Parte, $u_Lpresto_types$SignerRole$__Parte as $u_Lpresto_types$SignerRole$__Parte };
var $t_Lpresto_types$SignerRole$__Testemunha = null;
function $u_Lpresto_types$SignerRole$__Testemunha(x) {
  $t_Lpresto_types$SignerRole$__Testemunha = x;
}
export { $t_Lpresto_types$SignerRole$__Testemunha as $t_Lpresto_types$SignerRole$__Testemunha, $u_Lpresto_types$SignerRole$__Testemunha as $u_Lpresto_types$SignerRole$__Testemunha };
//# sourceMappingURL=presto.types$-Signer-Role$.js.map
